export function ArrowBackwardIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
      <path
        fill="currentColor"
        d="M3.29 12.705l.003.002 8 8a1 1 0 001.414-1.414L6.414 13H20a1 1 0 100-2H6.414l6.293-6.293a1 1 0 00-1.414-1.414l-8 8-.002.002a.997.997 0 000 1.41z"
      ></path>
    </svg>
  );
}
